module.exports = __webpack_public_path__ + "img/chatbot_whatsapp.45be3e74.jpg";